import { TimeLevelEnum } from "../enum/timelevel";

export const addTimelevelToDate = (date: Date, timelevel: TimeLevelEnum, value: number): Date => {
    const result = new Date(date);

    switch(timelevel) {
        case TimeLevelEnum.Daily:
            result.setDate(date.getDate() + value);
            break;
        case TimeLevelEnum.Weekly:
            result.setDate(date.getDate() + (value * 7));
            break;
        case TimeLevelEnum.Monthly:
            result.setMonth(date.getMonth() + value);
            break;
        case TimeLevelEnum.Quarterly:
            result.setMonth(date.getMonth() + (value * 3));
            break;
        case TimeLevelEnum.Yearly:
            result.setFullYear(date.getFullYear() + value);
            break;
    }

    return result;
}

export const convertStringToDate = (value: string) => {
    var conDate = new Date(Date.parse(value));
    return Date.UTC(conDate.getFullYear(), conDate.getMonth(), conDate.getDate(), 5, 0, 0, 0);
}